import { useSidebar } from '@startupquickstart/frontend';
import { useEffect } from 'react';
import { useSidebarConfig } from '@/config/sidebar';

export function SidebarSetup() {
  const { setBaseItems, setGroups } = useSidebar();
  const sidebarConfig = useSidebarConfig();

  useEffect(() => {
    setBaseItems(sidebarConfig.baseItems);
    setGroups(sidebarConfig.groups);
  }, [sidebarConfig, setBaseItems, setGroups]);

  return null;
}
